import $ from 'jquery';
import Ps from 'perfect-scrollbar';
import debounce from './utils/debounce';

class Filters {
    constructor(wrapperClass) {
        this.$wrapper       = $(wrapperClass);
        this.wrapperClass   = wrapperClass;
        this.speed          = 300;
        this.submitOnChange = false;

        // Selectors
        //----------------------------------------
        // Filter Selectors
        this.$form           = this.$wrapper.find(`${this.wrapperClass}__form`);
        this.$filters        = this.$wrapper.find(`${this.wrapperClass}__filter`);
        this.$filterHeadings = this.$wrapper.find(`${this.wrapperClass}__filter__heading`);
        this.$filterLists    = this.$wrapper.find(`${this.wrapperClass}__filter__list`);
        this.$checkboxes     = this.$wrapper.find(`${this.wrapperClass}__filter__list__item__checkbox`);
        this.$reset          = $(`${this.wrapperClass}__clear`);
        this.$submit         = this.$wrapper.find(`${this.wrapperClass}__submit`);

        // Mobile Filters
        this.$mobileFiltersToggle  = $('.js-filters-mobile-toggle');
        this.$mobileFiltersWrapper = $('.js-filters-mobile-wrapper');

        // Active Filter Selectors
        this.$activeFilters = $('.js-active-filter');

        // Events
        //----------------------------------------
        // Filter Events
        this.$checkboxes.on('click', $.proxy(this.checkboxChange, this));
        this.$filterHeadings.on('click', $.proxy(this.headingClick, this));
        this.$reset.on('click', $.proxy(this.resetClick, this));
        this.$submit.on('click', $.proxy(this.submitClick, this));
        $(document).on('click', $.proxy(this.documentClick, this));

        // Sorter Events
        $('.js-sorter__radio').on('change', $.proxy(this.submitClosestForm, this));

        // Mobile Events
        this.$mobileFiltersToggle.on('click', $.proxy(this.toggleMobileFilters, this));

        // Active Filter Events
        this.$activeFilters.on('click', $.proxy(this.activeFilterClick, this));

        // Escape Key
        $(document).keyup((e) => {
            if (e.keyCode === 27) {
                this.closeFilters(this.$filters);
            }
        });

        // Scrollbars
        //----------------------------------------
        this.scrollbars = [];

        this.addScrollbars();

        this.checkAllForCheckedItems();

        $(window).on('resize', $.proxy(this.closeAllFilters, this));

        $(window).on('resize', debounce(() => {
            this.updateScrollbars();
        }, 300));
    }

    addScrollbars() {
        for (let i = 0; i < this.$filterLists.length; i++) {
            this.scrollbars.push(new Ps(this.$filterLists[i]));
        }
    }

    updateScrollbars() {
        this.scrollbars.forEach((ps) => ps.update());
    }

    checkAllForCheckedItems() {
        // Check for active
        for (let i = 0; i < this.$filters.length; i++) {
            const $filter = $(this.$filters[i]);

            this.checkForCheckedItems($filter);
        }
    }

    checkForCheckedItems($filter) {
        if ($filter.find(':checked').length) {
            $filter.addClass('is-active');
        } else {
            $filter.removeClass('is-active');
        }
    }

    resetForm($form) {
        $form.find(`${this.wrapperClass}__filter__list__item__checkbox`).prop('checked', false);
        $form.find(`${this.wrapperClass}__hidden-input`).val('');

        this.checkAllForCheckedItems();
    }

    checkboxChange(e) {
        const $elem   = $(e.target);
        const $filter = $elem.closest(`${this.wrapperClass}__filter`);

        this.checkForCheckedItems($filter);

        if (this.submitOnChange) {
            this.submitForm();
        }
    }

    headingClick(e) {
        const $elem   = $(e.target);
        const $filter = $elem.closest(`${this.wrapperClass}__filter`);

        this.closeFilters(this.$filters.not($filter));

        $filter.toggleClass('is-open').find(`${this.wrapperClass}__filter__list`).slideToggle(this.speed, () => {
            this.updateScrollbars();
        });
    }

    documentClick(e) {
        const $elem = $(e.target);

        if (!$elem.closest(`${this.wrapperClass}__filter__list`).length && !$elem.closest(`${this.wrapperClass}__filter`).length) {
            this.closeFilters(this.$filters);
        }
    }

    closeFilters($filters) {
        $filters.removeClass('is-open').find(`${this.wrapperClass}__filter__list`).slideUp(this.speed);
    }

    closeAllFilters() {
        this.$filters.removeClass('is-open').find(`${this.wrapperClass}__filter__list`).slideUp(this.speed);
        this.$mobileFiltersWrapper.removeClass('is-open');
    }

    resetClick() {
        this.resetForm(this.$form);

        this.$form.submit();
    }

    submitClick(e) {
        const $elem = $(e.target);
        const $form = $elem.closest(`${this.wrapperClass}__form`);

        this.backToFirstPage();

        $form.submit();
    }

    submitForm() {
        this.backToFirstPage();
        this.$form.submit();
    }

    submitClosestForm(e) {
        const $elem = $(e.target);

        this.backToFirstPage();

        $elem.closest('form').submit();
    }

    backToFirstPage() {
        // Go to Page 1 when new filter clicked
        this.$form.find('input[name="current-page"]').remove();
        this.$form.find('input[name="hidden-current-page"]').remove();
        this.$form.append('<input type="hidden" name="hidden-current-page" value="1" />');
    }

    toggleMobileFilters() {
        this.$mobileFiltersToggle.toggleClass('is-open');
        this.$mobileFiltersWrapper.slideToggle('300');
    }

    activeFilterClick(e) {
        e.preventDefault();
        const $elem = $(e.target);

        const filterName  = $elem.closest(this.$activeFilters).data('name');
        const filterValue = $elem.closest(this.$activeFilters).data('value');

        // Check which filter corresponds to the active filter based on the name and value
        const $filter = this.$filters.find(`[for="${filterName}-${filterValue}"]`);

        if ($filter.length) {
            // Go back to the first page
            this.backToFirstPage();
            // Untick the filter
            $filter.trigger('click');
            // Submit the form with the unticked filter
            this.$form.submit();
        }
    }
}

export default Filters;
